<template>
  <div class="text-danger text-sm mb-1">
    Discount will be applied on the payment screen.
  </div>
  <div class="d-flex align-items-center justify-content-between gap-3">
    <el-input
      v-model="couponCode"
      placeholder="Enter discount code"
      class="coupon-input"
      :readonly="isCouponCodeApplied"
    ></el-input>
    <el-button
      class="apply-coupon w-auto mt-0"
      type="primary"
      @click="applyCoupon"
      :disabled="isApplyCouponDisabled"
    >
      {{ isCouponCodeApplied ? "Validated" : "Validate code" }}
    </el-button>
    <el-button
      v-if="isCouponCodeApplied"
      class="clear-coupon w-auto mt-0 ml-0"
      type="danger"
      @click="clearCoupon"
    >
      Clear
    </el-button>
  </div>
</template>
<script setup>
import { ref, computed, onBeforeMount, defineEmits } from "vue";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";

// Define the emit function
const emit = defineEmits(["updateDiscount", "clearCouponCode"]);

const $store = useStore();
const appliedCoupon = computed(() => $store.getters.appliedCoupon);
const couponCode = ref("");

const isCouponCodeApplied = computed(() => {
  return appliedCoupon.value && appliedCoupon.value.id ? true : false;
});

const isApplyCouponDisabled = computed(() => {
  return (
    couponCode.value === "" ||
    couponCode.value === undefined ||
    (isCouponCodeApplied.value && appliedCoupon.value.id)
  );
});

const applyCoupon = async () => {
  const result = couponCode.value.trim() !== "";

  if (!result) {
    ElMessage({
      type: "error",
      message: "Please enter a valid coupon code",
    });
    return;
  } else {
    try {
      const response = await $store.dispatch("APPLY_COUPON_CODE", {
        coupon: couponCode.value,
      });
      if (response && response.success) {
        // Emit the discount value to the parent
        // let returnDiscountData = {};

        // if (response.data.percentOff) {
        //   returnDiscountData = {
        //     type: "percent",
        //     percent: response.data.percentOff,
        //   };
        // }
        // if (response.data.amountOff) {
        //   returnDiscountData = {
        //     type: "amount",
        //     amount: response.data.amountOff,
        //     converted_amount: response.data.convertedAmountOff,
        //   };
        // }
        emit("updateDiscount", response);

        ElMessage({
          type: "success",
          message: response.message,
        });
      } else {
        ElMessage({
          type: "error",
          message: response.message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }
};

const clearCoupon = () => {
  couponCode.value = "";
  $store.dispatch("CLEAR_APPLIED_COUPON");
  emit("clearCouponCode", true);
};

onBeforeMount(() => {
  if (appliedCoupon.value && appliedCoupon.value.id) {
    couponCode.value = appliedCoupon.value.id;
    applyCoupon();
  }
});
</script>
